import { defineStore } from "pinia";
// import type Organisation from "../../../backend/app/models/organisation";

export const useOrgaStore = defineStore("orga", () => {
  const auth = useAuthStore();
  const toast = useToast();
  const needRefresh = useState("orga.needRefresh", () => false);

  // ===== TEMPORARY TESTING ORGANISATION =====
  // To test different scenarios, comment out the line below and uncomment one of the scenarios
  const organisation = computed(() => auth.orga); // Use real data

  // SCENARIO 1: No Subscription
  // const organisation = computed(() => ({
  //   id: 1,
  //   company_name: 'Test Organisation',
  //   subscription_id: null,
  //   subscription_status: null,
  //   subscription_plan: null,
  //   max_active_residents: null,
  //   last_payment: null,
  //   next_payment: null,
  //   subscription_ends_at: null,
  //   subscription_trial_ends_at: null,
  //   subscription_cancelled_at: null,
  //   subscription_paused_at: null,
  //   subscription_resumed_at: null,
  //   customer_id: null,
  //   customer_name: null,
  //   customer_email: null
  // }))

  // SCENARIO 2: Active Subscription
  // const organisation = computed(() => ({
  //   id: 1,
  //   company_name: "Test Organisation",
  //   subscription_id: "sub_123456789",
  //   subscription_status: "active",
  //   subscription_plan: "Growth Tier",
  //   max_active_residents: 25,
  //   last_payment: new Date().toISOString(),
  //   next_payment: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days from now
  //   subscription_ends_at: null,
  //   subscription_trial_ends_at: null,
  //   subscription_cancelled_at: null,
  //   subscription_paused_at: null,
  //   subscription_resumed_at: null,
  //   customer_id: "cus_123456789",
  //   customer_name: "John Doe",
  //   customer_email: "john@example.com",
  // }));

  // SCENARIO 3: Trial Subscription
  // const organisation = computed(() => ({
  //   id: 1,
  //   company_name: 'Test Organisation',
  //   subscription_id: 'sub_123456789',
  //   subscription_status: 'trialing',
  //   subscription_plan: 'Foundation Tier',
  //   max_active_residents: 11,
  //   last_payment: null,
  //   next_payment: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString(), // 14 days from now
  //   subscription_ends_at: null,
  //   subscription_trial_ends_at: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString(), // 14 days from now
  //   subscription_cancelled_at: null,
  //   subscription_paused_at: null,
  //   subscription_resumed_at: null,
  //   customer_id: 'cus_123456789',
  //   customer_name: 'John Doe',
  //   customer_email: 'john@example.com'
  // }))

  // SCENARIO 4: Paused Subscription
  // const organisation = computed(() => ({
  //   id: 1,
  //   company_name: 'Test Organisation',
  //   subscription_id: 'sub_123456789',
  //   subscription_status: 'paused',
  //   subscription_plan: 'Growth Tier',
  //   max_active_residents: 25,
  //   last_payment: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(), // 15 days ago
  //   next_payment: null,
  //   subscription_ends_at: null,
  //   subscription_trial_ends_at: null,
  //   subscription_cancelled_at: null,
  //   subscription_paused_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days ago
  //   subscription_resumed_at: null,
  //   customer_id: 'cus_123456789',
  //   customer_name: 'John Doe',
  //   customer_email: 'john@example.com'
  // }))

  // SCENARIO 5: Cancelled Subscription (still active until expiry)
  // const organisation = computed(() => ({
  //   id: 1,
  //   company_name: 'Test Organisation',
  //   subscription_id: 'sub_123456789',
  //   subscription_status: 'canceled',
  //   subscription_plan: 'Growth Tier',
  //   max_active_residents: 25,
  //   last_payment: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(), // 10 days ago
  //   next_payment: null,
  //   subscription_ends_at: new Date(Date.now() + 20 * 24 * 60 * 60 * 1000).toISOString(), // 20 days from now
  //   subscription_trial_ends_at: null,
  //   subscription_cancelled_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days ago
  //   subscription_paused_at: null,
  //   subscription_resumed_at: null,
  //   customer_id: 'cus_123456789',
  //   customer_name: 'John Doe',
  //   customer_email: 'john@example.com'
  // }))

  // SCENARIO 6: Expired Subscription
  // const organisation = computed(() => ({
  //   id: 1,
  //   company_name: 'Test Organisation',
  //   subscription_id: 'sub_123456789',
  //   subscription_status: 'canceled',
  //   subscription_plan: 'Growth Tier',
  //   max_active_residents: 25,
  //   last_payment: new Date(Date.now() - 35 * 24 * 60 * 60 * 1000).toISOString(), // 35 days ago
  //   next_payment: null,
  //   subscription_ends_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days ago (expired)
  //   subscription_trial_ends_at: null,
  //   subscription_cancelled_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days ago
  //   subscription_paused_at: null,
  //   subscription_resumed_at: null,
  //   customer_id: 'cus_123456789',
  //   customer_name: 'John Doe',
  //   customer_email: 'john@example.com'
  // }))

  // SCENARIO 7: Past Due Subscription
  // const organisation = computed(() => ({
  //   id: 1,
  //   company_name: 'Test Organisation',
  //   subscription_id: 'sub_123456789',
  //   subscription_status: 'past_due',
  //   subscription_plan: 'Growth Tier',
  //   max_active_residents: 25,
  //   last_payment: new Date(Date.now() - 35 * 24 * 60 * 60 * 1000).toISOString(), // 35 days ago
  //   next_payment: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days from now
  //   subscription_ends_at: null,
  //   subscription_trial_ends_at: null,
  //   subscription_cancelled_at: null,
  //   subscription_paused_at: null,
  //   subscription_resumed_at: null,
  //   customer_id: 'cus_123456789',
  //   customer_name: 'John Doe',
  //   customer_email: 'john@example.com'
  // }))

  // SCENARIO 8: Subscription Expiring Soon (3 days)
  // const organisation = computed(() => ({
  //   id: 1,
  //   company_name: 'Test Organisation',
  //   subscription_id: 'sub_123456789',
  //   subscription_status: 'active',
  //   subscription_plan: 'Growth Tier',
  //   max_active_residents: 25,
  //   last_payment: new Date(Date.now() - 27 * 24 * 60 * 60 * 1000).toISOString(), // 27 days ago
  //   next_payment: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString(), // 3 days from now
  //   subscription_ends_at: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString(), // 3 days from now
  //   subscription_trial_ends_at: null,
  //   subscription_cancelled_at: null,
  //   subscription_paused_at: null,
  //   subscription_resumed_at: null,
  //   customer_id: 'cus_123456789',
  //   customer_name: 'John Doe',
  //   customer_email: 'john@example.com'
  // }))

  // SCENARIO 9: Trial Ending Soon (2 days)
  // const organisation = computed(() => ({
  //   id: 1,
  //   company_name: 'Test Organisation',
  //   subscription_id: 'sub_123456789',
  //   subscription_status: 'trialing',
  //   subscription_plan: 'Foundation Tier',
  //   max_active_residents: 11,
  //   last_payment: null,
  //   next_payment: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days from now
  //   subscription_ends_at: null,
  //   subscription_trial_ends_at: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days from now
  //   subscription_cancelled_at: null,
  //   subscription_paused_at: null,
  //   subscription_resumed_at: null,
  //   customer_id: 'cus_123456789',
  //   customer_name: 'John Doe',
  //   customer_email: 'john@example.com'
  // }))

  async function getFramework() {
    const response = await auth.api("get", "/orga/framework");
    return response;
  }

  async function updateFramework(framework: string) {
    try {
      const response = await auth.api("post", "/orga/framework", {
        framework: framework,
      });

      return response;
    } catch (error) {
      console.error("Error updating framework:", error);
      throw error;
    }
  }

  async function updateOrganisation(payload: { company_name: string; description: string }) {
    try {
      const response = await auth.api("put", "/orga/update/", {
        company_name: payload.company_name,
        description: payload.description,
      });

      return response;
    } catch (error) {
      console.error("Error updating organisation:", error);
      throw error;
    }
  }

  async function getSubscriptionInfo() {
    try {
      // Return subscription info from the organisation data
      return {
        subscription_id: organisation.value?.subscription_id,
        subscription_status: organisation.value?.subscription_status,
        subscription_plan: organisation.value?.subscription_plan,
        max_active_residents: organisation.value?.max_active_residents,
        last_payment: organisation.value?.last_payment,
        next_payment: organisation.value?.next_payment,
        subscription_ends_at: organisation.value?.subscription_ends_at,
        subscription_trial_ends_at: organisation.value?.subscription_trial_ends_at,
        subscription_cancelled_at: organisation.value?.subscription_cancelled_at,
        subscription_paused_at: organisation.value?.subscription_paused_at,
        subscription_resumed_at: organisation.value?.subscription_resumed_at,
        customer_id: organisation.value?.customer_id,
        order_id: organisation.value?.order_id,
        customer_name: organisation.value?.customer_name,
        customer_email: organisation.value?.customer_email,
        customer_city: organisation.value?.customer_city,
        customer_region: organisation.value?.customer_region,
        customer_country_code: organisation.value?.customer_country_code,
      };
    } catch (error) {
      console.error("Error getting subscription info:", error);
      throw error;
    }
  }

  // Helper function to format dates consistently with your frontend patterns
  function formatDate(dateValue: any) {
    if (!dateValue) return null;

    // Handle Luxon DateTime objects (from backend) - convert to ISO string first
    if (dateValue && typeof dateValue.toISO === "function") {
      return new Date(dateValue.toISO()).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    }

    // Handle ISO string dates
    if (typeof dateValue === "string") {
      return new Date(dateValue).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    }

    return null;
  }

  // Helper function to get next billing date formatted
  function getNextBillingDate() {
    if (organisation.value?.next_payment) {
      return formatDate(organisation.value.next_payment);
    }
    return null;
  }

  // Helper function to get trial end date formatted
  function getTrialEndDate() {
    if (organisation.value?.subscription_trial_ends_at) {
      return formatDate(organisation.value.subscription_trial_ends_at);
    }
    return null;
  }

  async function refreshOrganisation() {
    try {
      // Fetch fresh organization data from server
      await auth.me(true); // Force refresh from server
      // No need to manually update organisation since it's now a computed that references auth.orga
      needRefresh.value = true;
    } catch (error) {
      console.error("Error refreshing organisation:", error);
      throw error;
    }
  }

  function triggerRefresh() {
    needRefresh.value = true;
  }

  async function removeMember(memberId: string) {
    try {
      await auth.api("delete", `/orga/member/`, { id: memberId });
      needRefresh.value = true;
    } catch (error) {
      console.error("Error removing member:", error);
      throw error;
    }
  }

  async function changeRole(memberId: string, role: string) {
    try {
      await auth.api("put", `/orga/member/`, {
        id: memberId,
        role: role,
      });
      needRefresh.value = true;
    } catch (error: any) {
      console.error("Error changing member role:", error);
      toast.add({
        title: "Error",
        description: error.message || "Could not change member role.",
        color: "error",
      });
    }
  }

  const stats = ref<{
    observations: number;
    tasks: number;
    residents: number;
    children: number;
    direct_works: number;
    users: number;
  } | null>(null);

  async function getStats() {
    try {
      const response = await auth.api("get", "/orga/stats/");
      stats.value = response.data;
      return response.data;
    } catch (error) {
      console.error("Error getting organisation stats:", error);
      return {
        observations: 0,
        tasks: 0,
        residents: 0,
        children: 0,
        direct_works: 0,
        users: 0,
      };
    }
  }

  return {
    organisation,
    needRefresh,
    stats,
    getFramework,
    updateFramework,
    updateOrganisation,
    getSubscriptionInfo,
    refreshOrganisation,
    triggerRefresh,
    formatDate,
    getNextBillingDate,
    getTrialEndDate,
    // Member management
    removeMember,
    changeRole,
    getStats,
  };
});
